import React from 'react'
import Usernav from '../Usernav';
import Sellernav from '../Sellernav';
import Adminnav from '../Adminnav';
import { useNavigate } from 'react-router-dom';
const Coupons = () => {

  var nav=useNavigate()
  function navAddCoupons(){
      nav('/AdminPanel/Coupons/AddCoupons')
  }
  function navRemoveCoupons(){
    nav('/AdminPanel/Coupons/RemoveCoupons')
}

  return (
    <>
      <Adminnav/>
   <div className="card h-100 text-center panel" >
                <div className="card-body row ">
                <i className="fas fa-plus icon col" onClick={()=>navAddCoupons()}></i>
                <i className="fas fa-minus icon col" onClick={()=>navRemoveCoupons()}></i>
                </div>
                <div className="card-body row content">
                <b className="col" style={{paddingLeft:"3.0px"}}>Add Coupons</b>
                <b className="col" style={{marginLeft:"25px"}}>Remove Coupons</b>
                </div>
            </div>
    </>
  )
}

export default Coupons